import PropTypes from 'prop-types'

// material-ui
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
// import Stack from '@mui/material/Stack'
import useMediaQuery from '@mui/material/useMediaQuery'

// third-party
import { BrowserView, MobileView } from 'react-device-detect'
import PerfectScrollbar from 'react-perfect-scrollbar'

import ProfileSection from '../Header/ProfileSection'
import Avatar from '@mui/material/Avatar'
import ButtonBase from '@mui/material/ButtonBase'
import { IconMenu2 } from '@tabler/icons-react'
import LogoSection from '../LogoSection'
import MenuList from './MenuList'
import { drawerWidth, drawerWidthMDClose } from '../../../../constants'

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({
  drawerOpen,
  drawerToggle,
  window
}: {
  drawerOpen: boolean
  drawerToggle: () => void
  window?: () => Window
}) => {
  const theme = useTheme()
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'))

  const drawer = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          p: 2,
          alignItems: 'center',
          flexShrink: 0,
          justifyContent: drawerOpen ? 'flex-start' : 'center'
        }}
      >
        <ButtonBase sx={{ borderRadius: '8px', overflow: 'hidden', mr: drawerOpen ? 2 : 0 }}>
          <Avatar
            variant='rounded'
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: 'all .2s ease-in-out',
              background: 'rgba(255,255,255,0.1)',
              color: '#fff',
              '&:hover': { background: 'rgba(255,255,255,0.2)' }
            }}
            onClick={drawerToggle}
            color='inherit'
          >
            <IconMenu2 stroke={1.5} size='1.3rem' />
          </Avatar>
        </ButtonBase>
        {drawerOpen && <LogoSection />}
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          '&::-webkit-scrollbar': {
            width: '4px'
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(255,255,255,0.1)',
            borderRadius: '4px'
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: 'rgba(255,255,255,0.2)'
          },
          px: drawerOpen ? 2 : 1
        }}
      >
        <MenuList />
      </Box>

      <Box
        sx={{
          p: 2,
          display: 'flex',
          justifyContent: 'center',
          borderTop: '1px solid rgba(255,255,255,0.1)',
          flexShrink: 0,
          bgcolor: '#1a1f2e' // Ensure footer has background
        }}
      >
        <ProfileSection />
      </Box>
    </Box>
  )

  const container = window !== undefined ? () => window().document.body : undefined

  return (
    <Box
      component='nav'
      sx={{ flexShrink: { md: 0 }, width: matchUpMd ? (drawerOpen ? drawerWidth : drawerWidthMDClose) : 'auto' }}
      aria-label='mailbox folders'
    >
      <Drawer
        container={container}
        variant={matchUpMd ? 'permanent' : 'temporary'}
        anchor='left'
        open={drawerOpen}
        onClose={drawerToggle}
        sx={{
          '& .MuiDrawer-paper': {
            width: drawerOpen ? drawerWidth : drawerWidthMDClose,
            background: '#1a1f2e',
            color: '#fff',
            borderRight: 'none',
            overflowX: 'hidden',
            transition: theme.transitions.create('width', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen
            })
          }
        }}
        ModalProps={{ keepMounted: true }}
        color='inherit'
      >
        {drawer}
      </Drawer>
    </Box>
  )
}

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object
}

export default Sidebar
